import { defineEntityContract, type EntityByIdRequests, type EntityStateEvents, type QueuedChangeFailureEvents } from 'shared/channels/entity';
import type {
  CreateSiteRequest,
  EditSiteRequest,
  SiteDeleteRequest,
  SiteRestoreRequest,
} from 'shared/domain/messages/site/eventMessages';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { SiteModel } from './types/model';

/**
 * Site events. Outcome payloads stay `unknown`: the HTTP queue sends `true`
 * after a save and `{ error, messageId }` with a failure; callers only wait
 * for the outcome and read the sites again.
 */
export type SiteEvents = EntityStateEvents & QueuedChangeFailureEvents & {
  [DomainMessagesTypes.allSites]: { hasAll?: boolean; items: SiteModel[] };
  [DomainMessagesTypes.uploadedEntity]: unknown;
  [DomainMessagesTypes.updatedEntity]: unknown;
  [DomainMessagesTypes.deletedEntity]: unknown;
};

/**
 * One site for its details view, and the site changes: each change resolves
 * once queued, its outcome follows as an event with its `uniqueId`.
 */
export type SiteRequests = EntityByIdRequests<SiteModel> & {
  create: { request: CreateSiteRequest; response: void };
  edit: { request: EditSiteRequest; response: void };
  remove: { request: SiteDeleteRequest; response: void };
  restore: { request: SiteRestoreRequest; response: void };
};

export const siteContract = defineEntityContract<SiteModel, SiteEvents, SiteRequests>('siteChannel', {
  collectionEvent: DomainMessagesTypes.allSites,
});
